import { render, staticRenderFns } from "./base-form-detail.vue?vue&type=template&id=73da0712&"
import script from "./base-form-detail.vue?vue&type=script&lang=js&"
export * from "./base-form-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports